<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" [useExistingCss]="true" style="margin-top: 2%;" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint>
            Print
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    
    <!-- WRAPPER DIV ADDED FOR BORDER -->
    <div class="print-border-wrapper" id="print-section">
        <div class="container" style="border: 2px solid black">

            <div class="row">
                <div class="col-2 image">
                    <img style="margin-top: 6%" width="85%" src="../../../assets/img/brand/red.png" />
                </div>
                <div class="col-8" style="padding-top: 30px; text-align: center; padding-bottom: 10px">
                    <span style="font-size: 35px;" class="ft-wt-500">हिंदुस्थान प्रकाशन संस्था</span>
                    <span style="font-size: 14px; margin-left: 05px">(Reg.No.-BOM-3/1961(GBDSD))</span>
                    <hr />
                    <div class="row" style="text-align: left">
                        <div class="col-6" style="padding-top: 10px">
                            <span style="font-size: 14px"><span class="ft-wt-500" style="font-size: 16px">प्रशासकीय
                                    कार्यालय :</span>
                                116-119, पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग, वडाला मुंबई -
                                400031<br /></span>
                            <span style="font-size: 14px"><span class="ft-wt-500" style=" font-size: 16px">दूरध्वनी:</span>
                                9967570531
                            </span>
                        </div>
                        <div class="col-6" style="
                  border-style: solid;
                  border-width: 0px 0px 0px 2px;
                  padding-top: 10px;
                ">
                            <span style="font-size: 14px"><span class="ft-wt-500" style=" font-size: 16px">मुख्य कार्यालय :
                                </span>
                                5/12, कामत औद्योगिक वसाहत,<br />
                                396 स्वा. वीर सावरकर मार्ग, प्रभादेवी, मुंबई 4000 25.<br /></span>
                            <span style="font-size: 14px"><span class="ft-wt-500" style=" font-size: 16px">दूरध्वनी :
                                </span>
                                24221440
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-2" style="
              border-style: solid;
              border-width: 0px 0px 0px 2px;
              text-align: center;
              display: flex;
              align-items: center;
            ">
                    <span style="font-size: 20px">क्रेडिट नोट पावती</span>
                </div>
            </div>
            <div class="row" style="
            border-style: solid;
            border-width: 2px 0px 0px 0px;
            text-align: center;
          ">
                <div class="col-6" style="padding-top: 20px; text-align: left">
                    <span class="ft-wt-500" style=" font-size: 16px">Advertieser Name : &nbsp;
                    </span><span style="font-size: 14px"><b>{{name}}</b></span><br />
                    <span class="ft-wt-500" style=" font-size: 16px">Address : &nbsp;</span>{{add}} <span
                        style="font-size: 14px"></span><br />
                    <span class="ft-wt-500" style=" font-size: 16px">Mobile No :&nbsp;</span><span
                        style="font-size: 14px">{{mobile}}</span>
                </div>
                <div class="col-6" style="border-style: solid; border-width: 0px 0px 0px 2px">
                    <div class="row" style="
                border-style: solid;
                border-width: 0px 0px 2px 0px;
                text-align: center;
                padding-top: 20px;
                padding-bottom: 10px;
              ">
                        <div class="col-6" style="text-align: left">
                            <span class="credit-no" style="font-weight: bold; font-size: 16px">क्रेडिट नोट क्रं.: </span><span
                                style="font-size: 14px">{{CreitVC}}</span>
                        </div>
                        <div class="col-6" style="text-align: left">
                            <span style="font-weight: bold; font-size: 16px">दिनांक :&nbsp;</span><span
                                style="font-size: 14px">
                                {{voc_date | date : "dd-MM-yyy"}}
                            </span>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 20px">
                        <div class="col-12" style="text-align: left">
                            <span style="font-weight: bold; font-size: 16px">तपशील : &nbsp;</span>
                            <span style="font-size: 14px">{{remark}}</span>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 05px">
                        <div class="col-6" style="text-align: left">
                            <span class="ft-wt-500" style=" font-size: 16px">&nbsp;</span><span
                                style="font-size: 14px"></span>
                        </div>
                        <!-- <div class="col-6" style="text-align: left">
                            <span style="font-weight: bold; font-size: 16px">दिनांक :&nbsp;</span>
                            <span style="font-size: 14px">
                                {{invoicedate | date : "dd-MM-yyy"}}
                            </span>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-12" style="text-align: left; padding-top: 05px">
                            <span style="font-size: 14px">
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="text-align: left; padding-top: 05px; padding-bottom: 10px">
                            <span style="font-weight: bold; font-size: 16px">क्रेडिट नोट रक्कम रु.&nbsp;</span><span
                                style="font-size: 14px">{{total_credit_amt}} /-</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="text-align: left; padding-top: 05px; padding-bottom: 10px">
                            <span style="font-weight: bold; font-size: 16px">अक्षरी रक्कम.&nbsp;</span><span
                                style="font-size: 14px"> {{totalinWords}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="
            border-style: solid;
            border-width: 2px 0px 0px 0px;
            text-align: center;
            padding-top: 20px;
          ">
                <div class="col-12" style="text-align: left; margin-top:10px;">
  <table style="width:100%; border:1px solid #000; border-collapse:collapse; text-align:center; font-size:14px;">
    <thead>
      <tr>
        <th style="border:1px solid #000; padding:6px;">Invoice No.</th>
        <th style="border:1px solid #000; padding:6px;">Invoice Date</th>
        <th style="border:1px solid #000; padding:6px;">Invoice Amt</th>
        <th style="border:1px solid #000; padding:6px;">Received Amt</th>
        <th style="border:1px solid #000; padding:6px;">Credit Note Amt</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="border:1px solid #000; padding:6px;">{{invoicenum}}</td>
        <td style="border:1px solid #000; padding:6px;">{{invoicedate | date:"dd-MM-yyy"}}</td>
        <td style="border:1px solid #000; padding:6px;">{{jama}}</td>
        <td style="border:1px solid #000; padding:6px;">{{rcv_amt}}</td>
        <td style="border:1px solid #000; padding:6px;">{{total_credit_amt}}</td>
      </tr>
 
    </tbody>
  </table>
</div>
            </div>


            <div class="row" style="margin-top: 100px; padding-bottom: 10px">
                <div class="col-6">
                </div>
                <div class="col-6" style="text-align: right; font-weight: bold; font-size: 16px">
                    <span>व्यवस्थापक / लेखापाल</span>
                </div>
            </div>
        </div>
    </div>
    <!-- END WRAPPER -->
</div>